import { createSlice, nanoid } from "@reduxjs/toolkit";
import type { TDialog } from "./types";

export const dialogSlice = createSlice({
  name: "dialog",
  initialState: [] as TDialog[],
  reducers: {
    openDialog: (state: TDialog[], action: { payload: TDialog }) => {
      const {
        id,
        content,
        props = {},
        zIndex,
        closeOnOutsideClick,
      } = action.payload;
      state.push({
        id: id || nanoid(),
        content,
        props,
        zIndex,
        closeOnOutsideClick,
      });
    },
    updateDialog: (
      state: TDialog[],
      action: { payload: { id: string; props: Record<string, unknown> } },
    ) => {
      const dialog = state.find((d) => d.id === action.payload.id);
      if (dialog) {
        dialog.props = { ...dialog.props, ...action.payload.props };
      }
    },
    closeDialog: (state: TDialog[], action: { payload: string }) => {
      return state.filter((dialog) => dialog.id !== action.payload);
    },
  },
});

export const { openDialog, updateDialog, closeDialog } = dialogSlice.actions;
